import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import USBLoader from '@usb-shield/components-react/dist/cjs/loader';
import { setNonSensitiveUserdetails } from '../../redux/actions';
import useEnv from '../../hooks/useEnv';
import {
    redirect,
    getAccessToken,
    getUserInfo,
    initiateJwtExpiryCounter,
} from '../../utils/authUtils';
import { resetCorrelationId } from '../../utils/dynamicDpsUtils';
import '../../styles/global.scss';

const LoginWrapperUpdate = ({
    baseUrl,
    authUrl,
    authTokenUrl,
    authClientId,
    requiredRoles,
    userInfoUrl,
    children,
}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { authSecret } = useEnv();
    const urlParams = new URLSearchParams(window.location.search);
    const _code = urlParams.get('code');
    const [code, setCode] = useState('');
    const _error = urlParams.get('error');
    const [authTokens, setAuthTokens] = useState({});
    const [authInProgress, setAuthInProgress] = useState(true);
    const [authError, setAuthError] = useState(false);
    const payload = {
        client_id: authClientId,
        client_secret: authSecret,
        redirect_uri: baseUrl,
    };

    useEffect(() => {
        if (_code && _code.length > 0) {
            setCode(_code);
        } else if (_error && _error.length > 0) {
            setAuthError(true);
        } else {
            const url = `${authUrl}?client_id=${authClientId}&response_type=code&scope=openid+profile+email&redirect_uri=${baseUrl}`;
            redirect(url);
        }
    }, []);

    useEffect(() => {
        if (code.length > 0) {
            getAccessToken(code, authTokenUrl, payload)
                .then((data) => {
                    setAuthTokens(data);
                })
                .catch(() => {
                    setAuthError(true);
                });
        }
    }, [code]);

    useEffect(() => {
        if (
            authTokens &&
            authTokens.access_token &&
            authTokens.access_token.length > 0
        ) {
            initiateJwtExpiryCounter(
                authTokens.refresh_token,
                authTokens.expires_in,
                setAuthTokens,
                code,
                authTokenUrl,
                payload,
            );

            if (!authTokens.isRefresh) {
                getUserInfo(authTokens.access_token, userInfoUrl)
                    .then((resp) => {
                        setAuthInProgress(false);
                        dispatch(setNonSensitiveUserdetails(resp));
                        if (resp) {
                            if (requiredRoles) {
                                let hasRoles = false;
                                const userRoles = resp.roles;

                                if (
                                    userRoles &&
                                    (Array.isArray(userRoles) ||
                                        typeof roles === 'string')
                                ) {
                                    const userRolesArray =
                                        Array.isArray(userRoles)
                                            ? userRoles
                                            : [userRoles];
                                    hasRoles = requiredRoles.some(
                                        (role) =>
                                            userRolesArray.includes(
                                                role,
                                            ),
                                    );
                                }
                                // Role missing error
                                if (!hasRoles) {
                                    history.push(
                                        '/banker/role-error',
                                    );
                                }
                            }
                        }
                    })
                    .catch(() => {
                        setAuthError(true);
                    });
            }
        }
    }, [authTokens.access_token]);

    if (authInProgress) {
        return (
            <div className="app-loader">
                <USBLoader />
            </div>
        );
    }

    if (authError) {
        resetCorrelationId();
        history.push(`/banker/error`);
    }

    return children;
};

export default LoginWrapperUpdate;
